import { useState, useEffect, useContext } from "react";
import { Formik, Form as FormikForm } from "formik";
import { Row, Col, Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import axios from "axios";
import "../components/button.css";
import { API_URL } from "../config/api";
import { TextField, Button } from "@mui/material";
import LockResetOutlinedIcon from "@mui/icons-material/LockResetOutlined";
import { page } from "../config/layout";
import { UserDataContext } from "../components/UserDataContext";
import Alerts from "../components/Alerts";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../components/theme";
import FormPage from "../components/common/FormPage";
import FormHeader from "../components/common/FormHeader";
import PrimaryButton from "../components/common/PrimaryButton";

const validationSchema = Yup.object().shape({
  email: Yup.string()
    .email("Nieprawidłowy adres email")
    .required("Email jest wymagany"),
  password: Yup.string()
    .min(8, "Hasło musi mieć co najmniej 8 znaków")
    .matches(/[0-9]/, "Hasło musi zawierać co najmniej jedną cyfrę")
    .matches(
      /[!@#$%^&*(),.?":{}|<>]/,
      "Hasło musi zawierać co najmniej jeden znak specjalny",
    )
    .required("Hasło jest wymagane"),
  repeatpassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Hasła muszą być takie same")
    .required("Potwierdzenie hasła jest wymagane"),
});

export default function PassResetMail({ group }) {
  const [error, setError] = useState();
  const [errorText, setErrorText] = useState("");
  const { userData } = useContext(UserDataContext);
  const [email, setEmail] = useState("");
  const [readOnly, setReadOnly] = useState(true);
  const [apiResponse, setApiResponse] = useState({});
  const [showApiResponse, setShowApiResponse] = useState("");
  const [text, setText] = useState("");
  const [cnt, setCnt] = useState(0);
  const navigate = useNavigate();

  const initialValues = {
    email: "",
    password: "",
    repeatpassword: "",
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    setEmail(values.email);
    console.log("Values to reset pass: ", values);
    if (cnt < 1) {
      try {
        const response = await axios.post(
          API_URL + "/registernewpassword",
          values,
        );
        console.log("RD: ", response.data);
        setError(response.data.error_msg);
      } catch (error) {
        console.error("Błąd podczas rejestracji!", error);
      } finally {
        setSubmitting(false);
      }
      setCnt(cnt + 1);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const url = API_URL + `/passresetmail`;
      try {
        const response = await axios.post(
          url,
          { email: email },
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        );
        if (parseInt(response.data.email) > 0) {
          setReadOnly(false);
          setText("Email zweryfikowany poprawnie!");
        } else {
          setReadOnly(true);
          setText(
            "Brak adresu email na liście uprawnionych lub konto jest nieaktywne",
          );
        }
      } catch (error) {
        setError(error.message);
      }
    };
    fetchData();
  }, [email, error]);

  useEffect(() => {
    console.log("error: ", error);
    if (error === 200) {
      setApiResponse({
        title: "Informacja",
        severity: "success",
        info: "Potwierdzenie wysłane na wskazany adres email!",
      });
      setShowApiResponse(true);
      const timeoutId = setTimeout(() => {
        navigate("/login");
      }, 2000);
      return () => clearTimeout(timeoutId);
    } else {
      console.log("error: ", error);
    }
  }, [error]);

  return (
    <FormPage>
      <FormHeader
        icon={<LockResetOutlinedIcon />}
        title="Ustaw nowe hasło"
        subtitle="Odzyskaj dostęp do swojego konta."
        description="Po zweryfikowaniu adresu e-mail będziesz mógł ustawić nowe hasło."
      />
      {showApiResponse && (
        <Row>
          <Alerts data={apiResponse} />
        </Row>
      )}
      <Container>
        <ThemeProvider theme={theme}>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({
              isSubmitting,
              handleChange,
              handleBlur,
              values,
              errors,
              touched,
            }) => (
              <FormikForm>
                <TextField
                  autoComplete="off"
                  label="Email użytkownika"
                  name="email"
                  type="email"
                  value={values.email}
                  onChange={(e) => {
                    handleChange(e);
                    setEmail(e.target.value);
                  }}
                  onBlur={handleBlur}
                  fullWidth
                  error={touched.email && Boolean(errors.email)}
                  helperText={touched.email && errors.email}
                  margin="normal"
                />
                {text}
                <br></br>
                <TextField
                  label="Hasło"
                  name="password"
                  type="password"
                  value={values.password}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  fullWidth
                  error={touched.password && Boolean(errors.password)}
                  helperText={touched.password && errors.password}
                  margin="normal"
                  InputProps={{ readOnly }}
                />
                <TextField
                  label="Powtórz hasło"
                  name="repeatpassword"
                  type="password"
                  value={values.repeatpassword}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  fullWidth
                  error={
                    touched.repeatpassword && Boolean(errors.repeatpassword)
                  }
                  helperText={touched.repeatpassword && errors.repeatpassword}
                  margin="normal"
                  InputProps={{ readOnly }}
                />
                {error !== "sent" && (
                  <PrimaryButton loading={isSubmitting}>
                    Wyślij link z potwierdzeniem
                  </PrimaryButton>
                )}
                {error === "sent" && (
                  <h6>Wiadomość wysłana. Sprawdź pocztę.</h6>
                )}
              </FormikForm>
            )}
          </Formik>
        </ThemeProvider>
      </Container>
    </FormPage>
  );
}

/*

                  <Button
                    variant="outlined"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    Wyślij link z potwierdzeniem
                  </Button>
*/
